import React, { useRef, useState, useEffect } from 'react';
import RagnaDataTable from '../ReactComponents/RagnaDataTable.jsx';
import axios from 'axios';
import { ajax_api } from '../../Globals.jsx';
import { useOutlet, Outlet, useOutletContext } from 'react-router-dom';
import RagnaWindow from '../ReactComponents/RagnaWindow';
import RagnaModal from '../ReactComponents/RagnaModal';
import { useForm } from 'react-hook-form';
import { MultiSelect } from '../ReactComponents/MultiSelect.jsx';
import Select from 'react-select';
import { Helmet } from 'react-helmet';
import RagnaLoader from '../ReactComponents/RagnaLoader.jsx';

const CouncilCommittees = props => {
    //datatable options
    const [refreshTable] = useOutletContext();
    const [refreshMain, setRefreshMain] = useState(-1);


    const table_columns = [
        { display: "Name", col: "Name" },
        { display: "Members", col: "Members" },
    ];
    const search_columns = [
        { display: "Name", col: "Name" }
    ];
    const outlet = useOutlet();

    const [loading, setLoading] = useState(false);
    const [council, setCouncil] = useState(-1);
    const [councils, setCouncils] = useState(-1);
    const [loaded, setLoaded] = useState(false);
    const [errorOptions, setErrorOptions] = useState("");
    const [modalOpen, setModalOpen] = useState(false);

    const [origCommittees, setOrigCommittees] = useState([]);
    const [selectedCommittees, setSelectedCommittees] = useState([]);
    const [optionCommittees, setOptionCommittees] = useState([]);

    const [isSaving, setIsSaving] = useState(false);
    const { handleSubmit, register, watch } = useForm();

    const [OfficialOptions, setOfficialOptions] = useState([]);
    const [OffTypeOptions, setOffTypeOptions] = useState([]);

    const [memberListErrorState, setMemberListErrorState] = useState("");

    useEffect(_ => {
        (async function () {
            //get officials option
            var loaded = 0;
            await axios.get(ajax_api + "items/getOption/councils/", {withCredentials: true})
                .then(response => {
                    var d = [...response.data];
                    d.sort((a, b) => b.label.replace(/\D/g, '') - a.label.replace(/\D/g, ''));
                    setCouncils(d);
                    loaded++;
                }).catch(e => setErrorOptions(e));
            await axios.get(ajax_api + "items/getOption/committees/", { withCredentials: true })
                .then(response => {
                    var d = [...response.data];
                    setOptionCommittees(d);
                    loaded++;
                }).catch(e => setErrorOptions(e));
            await axios.get(ajax_api + "items/getOption/officials/", { withCredentials: true })
                .then(response => {
                    var d = response.data.map(o => (
                        {
                            label: o.label.split(" ").map(str => {
                                var initials = ["II", "III", "IV", "VI", "VII", "VIII", "VIII"];
                                if (initials.some(ii => str == ii || str + "." == ii)) return str.toUpperCase();
                                return str[0] ? (str[0].toUpperCase() + str.substring(1).toLowerCase()) : "";
                            }).join(" "), value: o.value
                        }
                    ));
                    d.sort((a, b) => a.label > b.label);
                    setOfficialOptions(d);
                    loaded++;
                }).catch(e => setErrorOptions(e));
            await axios.get(ajax_api + "items/getOption/committee_types/", { withCredentials: true })
                .then(response => {
                    var d = [...response.data];
                    setOffTypeOptions(d);
                    loaded++;
                }).catch(e => setErrorOptions(e));
            if (loaded >= 4) {
                setLoaded(true);
            }
        })();
    }, [])
    useEffect(_ => {
        setLoading(true);
        if (council > 0) {
            (async function () {
                //get officials option
                await axios.get(ajax_api + "councils/get-options-council-committees/" + council, { withCredentials: true })
                    .then(response => {
                        var d = [...response.data];
                        setSelectedCommittees(d);
                        setOrigCommittees(d);
                        setLoading(false);
                    }).catch(e => setErrorOptions(e));
            })();
        }
    }, [council])
    useEffect(() => {
        const subscription = watch((value, { name, type }) => console.log()); //value, name, type
        return () => subscription.unsubscribe();
    }, [watch]);

    const watchCouncil = watch("council", council);

    const saveCommittees = _ => {
        if (council > 0) {
            (async () => {
                setIsSaving(true);

                var f = new FormData();
                f.append("committees", JSON.stringify(selectedCommittees));

                await axios.post(`${ajax_api}councils/save-council-committees/${council}`, f, { withCredentials: true }).then(_ => {
                    setModalOpen(false)
                    setRefreshMain(r => r + 1);
                }).catch(e => alert(e));


                setIsSaving(false);
            })();
        }
    };

    const [memberModalOpen, setMemberModalOpen] = useState(false);

    const [selectedCommitteeName, setSelectedCommitteeName] = useState("-");
    const [members, setMembers] = useState([]);
    const customContainer = useRef(null);
    const [loadingMemberList, setLoadingMemberList] = useState(false);
    const getCouncilName = e => {
        return councils.filter(c => c.value == e).length > 0 ? councils.filter(c => c.value == e)[0].label : ""
    }
    const [committee, setCommittee] = useState(-1);

    const setCommitteeOfficials = _ => {
        if (!loadingMemberList) {
            if (members.some(m => m.Official < 0 || m.Type < 0)) {
                setLoadingMemberList(false);
                alert("Validation error. Check input for missing values.")
                return;
            }
            if (members.length != new Set(members.map(m => m.Official)).size) {
                alert("Validation error. Check input for duplicate members.")
                return;
            }

            setLoadingMemberList(true);

            var f = new FormData();
            f.append("members", JSON.stringify(members));
            console.log("=> " + JSON.stringify(members));

            (async () => {
                await axios.post(`${ajax_api}councils/save-committee-members/${council}/${committee}`, f, { withCredentials: true })
                    .then(_ => {
                        setMemberModalOpen(false);
                        setRefreshMain(r => r + 1);
                    }).catch(e => alert(e));
                setLoadingMemberList(false);
            })();
        }
    }

    return <>
        <Helmet>
            <title>LTS | Manage Committee Members</title>
        </Helmet>
        {
            outlet != null ? <Outlet /> :
                (
                    loaded == false ? <>
                        <RagnaWindow mainStyle={{ marginTop: 100, display: "flex", justifyContent: "center" }} boxStyle={{ minHeight: 0 }}>
                            {
                                errorOptions == "" ? <>
                                    <RagnaLoader text="Loading Councils" />
                                </> : <div className="alert alert-danger">
                                    Error! {errorOptions}
                                    Click <a href="#">here</a> to try again
                                </div>
                            }
                        </RagnaWindow>
                    </> :
                        <>

                            <RagnaModal
                                title={loadingMemberList || memberListErrorState ? "" : "Manage Council Committee Members"}
                                width={loadingMemberList ? 300 :  memberListErrorState ? 500 : 700}
                                boxStyle={loadingMemberList || memberListErrorState ? { minHeight: 0 } : {}}
                                noBackdropClose={loadingMemberList}
                                hideClose={loadingMemberList}
                                body={<>
                                    {
                                        loadingMemberList ?
                                            <>
                                                <RagnaLoader text="Loading Committee Members" />
                                            </> :
                                            (
                                                memberListErrorState != "" ? <div className="alert alert-danger">
                                                    {memberListErrorState}
                                                </div> :
                                                    <>
                                                        <div className="row">
                                                            <div className="col-10 position">
                                                                <h4>
                                                                    {`${selectedCommitteeName}`}
                                                                </h4>
                                                                <div>
                                                                    {`${getCouncilName(council)}`}
                                                                </div>
                                                            </div>
                                                            <div className="col">
                                                                <button className="ro-button" onClick={
                                                                    _ => {
                                                                        var s = [...members];
                                                                        s.push({
                                                                            Official: -1,
                                                                            Type: -1,
                                                                        })
                                                                        setMembers(s)
                                                                    }
                                                                }>
                                                                    <span>Add Member</span>
                                                                </button>
                                                            </div>
                                                    </div>
                                                        <hr />
                                                        <div ref={customContainer}
                                                        style={{
                                                            maxHeight: 300,
                                                            overflowX: "hidden",
                                                            overflowY: "auto"
                                                        }}>
                                                        {
                                                            (
                                                                members.length > 0 ?
                                                                    members.map((m, i) => {
                                                                        return <div className="row mb-1 px-2 justify-items-center align-items-center" key={i}>
                                                                            <div className="col position-relative">{i + 1}</div>
                                                                            <div className="col-5 position-relative">
                                                                                <Select
                                                                                    menuPortalTarget={document.querySelector('body')}
                                                                                    value={OfficialOptions.filter(e => e.value == members[i].Official)}
                                                                                    className={
                                                                                        members[i].Official == -1 ?
                                                                                            "border-danger border rounded" : ""
                                                                                    }
                                                                                    onChange={e => {
                                                                                        var arr = [...members];
                                                                                        arr[i] = {
                                                                                            ...arr[i],
                                                                                            Official: e.value
                                                                                        }
                                                                                        setMembers(arr);
                                                                                    }}
                                                                                    options={OfficialOptions.filter(o => !members?.map(m => m.Official).includes(o.Official))} />
                                                                            </div>
                                                                            <div className="col-4 position-relative">
                                                                                <Select
                                                                                    menuPortalTarget={document.querySelector('body')}
                                                                                    value={OffTypeOptions.filter(e => e.value == members[i].Type)}
                                                                                    className={
                                                                                        members[i].Type == -1 ?
                                                                                            "border-danger border rounded" : ""
                                                                                    }
                                                                                    onChange={e => {
                                                                                        var arr = [...members];
                                                                                        arr[i] = {
                                                                                            ...arr[i],
                                                                                            Type: e.value
                                                                                        }
                                                                                        setMembers(arr);
                                                                                    }}
                                                                                    options={OffTypeOptions} />
                                                                            </div>
                                                                            <div className="col-2 d-flex justify-content-end">
                                                                                <button onClick={
                                                                                    _ => {
                                                                                        var s = [...members]
                                                                                        s.splice(i, 1)
                                                                                        setMembers(s)
                                                                                    }
                                                                                }
                                                                                    className="btn btn-danger rounded">
                                                                                    <i className="fa fa-trash" />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    })
                                                                    : "- no members -"
                                                            )
                                                        }
                                                    </div>
                                        </>
                                            )
                                    }
                                </>}
                                footer={
                                    loadingMemberList || memberListErrorState ? null : (
                                        <div className="px-2">
                                            <button
                                                className="ro-button"
                                                onClick={setCommitteeOfficials}
                                            >
                                                <span>Save</span>
                                            </button>
                                        </div>
                                    )
                                }
                                noBtn={true}
                                modalOpen={memberModalOpen}
                                setModalOpen={setMemberModalOpen}
                            />
                        <div className="row">
                            <div className="col-3">
                                <RagnaWindow boxStyle={{ minHeight: 0 }}>
                                    <form onSubmit={handleSubmit(e => {
                                        setRefreshMain(e => e + 1)
                                        setCouncil(e.council)
                                    })}>
                                        <select className="form-select" {...register("council")}>
                                            {
                                                councils.map((c, i) => <option value={c.value} key={i}>{c.label}</option>)
                                            }
                                        </select>
                                        <button className="ro-button mt-2 w-100">
                                            <span><i className="fa fa-sync" /> Load Table</span>
                                        </button>
                                    </form>
                                    <hr />
                                    <RagnaModal
                                        btnClass="w-100"
                                        btnProps={(council > 0) && (watchCouncil == council) ? {} : { disabled: true }}
                                        modalOpen={modalOpen}
                                        setModalOpen={setModalOpen}
                                        body={
                                            loading ? <>Loading committees..</> :
                                            <>
                                                <div style={{ textDecoration: "underline" }}>
                                                    Selected Council:
                                                </div>
                                                <div>
                                                    {councils.filter(c => c.value == council)[0]?.label}
                                                </div>
                                                <MultiSelect
                                                    origValues={origCommittees}
                                                    options={optionCommittees}
                                                    setSelected={setSelectedCommittees}
                                                    selected={selectedCommittees} />
                                                <hr />
                                                <div>
                                                    <button disabled={isSaving}
                                                        style={{ pointerEvents: isSaving ? "none" : "initial" }}
                                                        className="ro-button float-end" onClick={saveCommittees}>
                                                        <span>Save</span>
                                                    </button>
                                                </div>
                                            </>
                                        }
                                        trigName={<><i className="fa fa-cog" /> Manage Committees</>}
                                    />
                                </RagnaWindow>
                            </div>
                            <div className="col-9">
                                {
                                    council > 0 ? <>
                                        <RagnaDataTable
                                            key={"tbl"+council}
                                            refreshTable={refreshTable + refreshMain}
                                            title={`Council Committees <${councils.filter(c => c.value == council)[0]?.label}>`}
                                            columns={table_columns}
                                            s_columns={search_columns}
                                            defaultOrder={false}
                                            maxPagination={8}
                                            generalSearch={true}
                                            defaultOrderCol="ID"
                                            url={ajax_api + "councils/get-council-committees/" + council}
                                            actions={
                                                [
                                                    {
                                                        component: p => {
                                                            var { data } = p;
                                                            return <button className="ro-button" onClick={_ => {
                                                                setLoadingMemberList(true);
                                                                setMemberModalOpen(true);
                                                                setCommittee(data.Id);

                                                                setSelectedCommitteeName(data.Name);

                                                                setMemberListErrorState("");
                                                                (async () => {
                                                                    await axios.get(`${ajax_api}councils/get-committee-members/${council}/${data.Id}`, { withCredentials: true })
                                                                        .then(r => setMembers(r.data))
                                                                        .catch(e => {
                                                                            setMemberListErrorState("Error: " + e);
                                                                        });
                                                                    setLoadingMemberList(false);
                                                                })();
                                                            }}>
                                                                <span>Manage</span>
                                                            </button>;
                                                        }
                                                    }
                                            ]}
                                        />
                                    </> : <RagnaWindow>Please Select a Council</RagnaWindow>
                                }

                            </div>
                        </div >
                    </>
                    )
        }
    </>
}

export default CouncilCommittees;